
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/reporting",
      function () {
        return require("private-next-pages/features/reporting.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/reporting"])
      });
    }
  